import { GridColumn } from 'src/components/GridWrapper';
import ActualizedAmountColumnDetailCell from 'src/components/custom-cells/ActualizedAmountColumnDetailCell';
import ActualizedAmountColumnDetailHeaderCell from 'src/components/custom-cells/ActualizedAmountColumnDetailHeaderCell';

import AmountColumn from 'src/sections/view_checkbook/AmountColumn';
import DateCell from 'src/sections/view_checkbook/hold_amount_cell/DateCell';
import Action from 'src/sections/view_checkbook/spent_amount_cell/Action';
import GoToPoJournal from 'src/sections/view_checkbook/spent_amount_cell/GoToPoJournal';
import PoSubjectCreditMemo from 'src/sections/view_checkbook/spent_amount_cell/PoSubjectCreditMemo';
import TotalAmountCell from 'src/sections/view_checkbook/spent_amount_cell/TotalAmountCell';

export const useActualizedAmountColumns = () => {
  const actualizedAmountColumns: GridColumn<any>[] = [
    {
      field: 'expanded',
      width: 45,
      component: ActualizedAmountColumnDetailCell,
      menu: false,
      headerCell: ActualizedAmountColumnDetailHeaderCell,
      sortable: false,
    },
    {
      field: 'date',
      title: 'Date',
      filter: 'date',
      component: DateCell,
      headerCellTooltip: 'Transaction Date',
    },
    {
      field: 'user',
      title: 'User',
      filter: 'text',
      dataType: 'string',
    },
    {
      field: 'documentNumber',
      title: 'PO/Journal Entry #',
      filter: 'text',
      dataType: 'string',
      component: GoToPoJournal,
    },
    {
      field: 'action',
      title: 'Action',
      filter: 'text',
      dataType: 'string',
      component: Action,
      headerCellTooltip: 'Type of Action',
    },
    {
      field: 'total',
      title: '$ Total',
      filter: 'numeric',
      dataType: 'dollar',
      format: '{0:c2}',
      filterFormat: 'c2',
      component: TotalAmountCell,
      headerCellTooltip: 'Transaction amount for this GL code and period',
    },
    {
      field: 'actionNotes',
      title: 'PO Subject/Invoice/Credit Memo Notes',
      filter: 'text',
      dataType: 'string',
      component: PoSubjectCreditMemo,
    },
    {
      field: 'comments',
      title: 'Comments',
      filter: 'text',
      dataType: 'string',
    },
  ];
  return actualizedAmountColumns;
};

export const useActualizedAmountDetailColumns = () => {
  const actualizedAmountDetailColumns: GridColumn<any>[] = [
    {
      field: 'lineItem',
      title: 'Line Item',
      filter: 'text',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'itemNum',
      title: 'Item #',
      filter: 'text',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'description',
      title: 'Description',
      filter: 'text',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'amount',
      title: 'Amount',
      filter: 'numeric',
      dataType: 'dollar',
      format: '{0:c2}',
      filterFormat: 'c',
      menu: false,
      component: AmountColumn,
    },
  ];
  return actualizedAmountDetailColumns;
};
